import { render, staticRenderFns } from "./warning-icon.vue?vue&type=template&id=5fb23766&"
import script from "./warning-icon.vue?vue&type=script&lang=ts&"
export * from "./warning-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports